import React from 'react';
import { PumpFullEditTemplate } from 'themes/application/pumps/components';
import { observer } from 'mobx-react';
import { PumpEditViewStore } from 'application/pumps/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PumpEditViewStore(rootStore, componentProps), 'editView')
@observer
class PumpFullEdit extends React.Component {
    render() {
        return <PumpFullEditTemplate {...this.props} />
    }
}

export default PumpFullEdit;